const mr = {
  nav: {
    login: 'लॉगिन',
    bookNow: 'आता बुक करा',
    dashboard: 'डॅशबोर्ड',
    back: 'मागे',
    home: 'होम',
  },
  landing: {
    heroTitle1: 'आकाशातील प्रवास,',
    heroTitle2: 'आता सोपा',
    heroSubtitle: 'भारतातील अग्रगण्य हेलिकॉप्टर चार्टर अ‍ॅग्रीगेटर. सत्यापित ऑपरेटरशी जोडा, त्वरित उड्डाणे बुक करा आणि आकाशाला गवसणी घाला.',
    bookYourFlight: 'तुमचे उड्डाण बुक करा',
    becomeOperator: 'ऑपरेटर व्हा',
    whyChoose: 'AirYatra का निवडावे?',
    verifiedOperators: 'सत्यापित ऑपरेटर',
    verifiedOperatorsDesc: 'सर्व ऑपरेटर AOC प्रमाणपत्रे, विमा आणि सुरक्षा अनुपालनासह पूर्णपणे सत्यापित आहेत.',
    bestPrices: 'सर्वोत्तम किंमती',
    bestPricesDesc: 'AI-आधारित किंमत सूचना तुम्हाला अनेक ऑपरेटरकडून स्पर्धात्मक कोटेशन मिळवून देतात.',
    seamlessBooking: 'सुलभ बुकिंग',
    seamlessBookingDesc: 'कोटेशन विनंतीपासून डिजिटल तिकिटांपर्यंत, तुमचा संपूर्ण प्रवास एकाच प्लॅटफॉर्मवर व्यवस्थापित करा.',
    flightsCompleted: 'पूर्ण उड्डाणे',
    verifiedOperatorsStat: 'सत्यापित ऑपरेटर',
    safetyRecord: 'सुरक्षा रेकॉर्ड',
    customerRating: 'ग्राहक रेटिंग',
    premiumServices: 'प्रीमियम सेवा',
    elevateExperience: 'तुमचा अनुभव उंचावा',
    premiumSubtitle: 'आमच्या प्रीमियम सदस्यत्व आणि कॉर्पोरेट प्रवास उपायांसह विशेष लाभ मिळवा',
    blackDesc: '20% पर्यंत सूट, प्राधान्य बुकिंग, समर्पित पायलट आणि विशेष लाउंज प्रवेशासह प्रीमियम सदस्यत्व.',
    priorityQueue: 'प्राधान्य बुकिंग रांग',
    dedicatedManager: 'समर्पित रिलेशनशिप मॅनेजर',
    freeCancellation: 'मोफत रद्दीकरण',
    exploreMembership: 'सदस्यत्व पहा',
    corporateConsole: 'कॉर्पोरेट कन्सोल',
    corporateDesc: 'मंजुरी वर्कफ्लो, बजेट आणि एकत्रित बिलिंगसह उद्योगांसाठी केंद्रीकृत प्रवास व्यवस्थापन.',
    employeeManagement: 'कर्मचारी व्यवस्थापन',
    budgetControls: 'बजेट नियंत्रण',
    travelAnalytics: 'प्रवास विश्लेषण',
    corporateRegistration: 'कॉर्पोरेट नोंदणी',
    documentVault: 'दस्तऐवज व्हॉल्ट',
    vaultDesc: 'DGCA दस्तऐवज, विमा, परवान्यांसाठी सुरक्षित एनक्रिप्टेड स्टोरेज - मुदत समाप्ती अलर्ट आणि आवृत्ती नियंत्रणासह.',
    encryption: 'AES-256 एनक्रिप्शन',
    expiryReminders: 'मुदत समाप्ती स्मरणपत्रे',
    secureSharing: 'सुरक्षित शेअरिंग',
    openVault: 'व्हॉल्ट उघडा',
    loginToAccess: 'प्रवेशासाठी लॉगिन करा',
    readyTakeOff: 'उड्डाणासाठी तयार?',
    ctaSubtitle: 'आजच तुमचे हेलिकॉप्टर चार्टर बुक करा आणि विमानन उत्कृष्टतेचा अनुभव घ्या.',
    startBooking: 'बुकिंग सुरू करा',
    footerText: '© 2025 AirYatra. सर्व हक्क राखीव. भारतातील अग्रगण्य हेलिकॉप्टर चार्टर प्लॅटफॉर्म.',
  },
  booking: {
    title: 'तुमचे उड्डाण बुक करा',
    subtitle: 'AirYatra - प्रीमियम एअर मोबिलिटी सेवा',
    previous: 'मागील',
    next: 'पुढील',
    loginPrompt: 'बुकिंग चौकशीसाठी कृपया लॉगिन करा',
    loginBtn: 'लॉगिन करा',
    steps: {
      passengers: 'प्रवासी',
      booking_type: 'बुकिंग प्रकार',
      route: 'मार्ग',
      price_inquiry: 'किंमत',
    },
  },
  bookingForm: {
    selectAircraftType: 'विमान प्रकार निवडा',
    maxPassengers: 'कमाल {{count}} प्रवासी',
    adultPassengers: 'प्रौढ प्रवासी',
    male: 'पुरुष',
    female: 'महिला',
    totalAdults: 'एकूण प्रौढ',
    children: 'मुले (4 वर्षांपर्यंत)',
    childrenFree: 'मोफत - कमाल 2 मुले',
    flightType: 'उड्डाणाचा प्रकार',
    selectOption: '-- निवडा --',
    bookingFor: 'बुकिंग कोणासाठी',
    bookingPurpose: 'बुकिंगचा उद्देश',
    selected: 'निवडले',
    specifyPurpose: 'उद्देश सांगा',
    pickupLocation: 'पिकअप ठिकाण',
    selectPickupPoint: 'पिकअप पॉइंट निवडा',
    dropLocation: 'ड्रॉप ठिकाण',
    selectDropPoint: 'ड्रॉप पॉइंट निवडा',
    estimatedDistance: 'अंदाजे अंतर',
    villageDocsTitle: 'गाव लँडिंग - कागदपत्रे आवश्यक',
    villageDocsDesc: 'गाव/खाजगी जमिनीवर लँडिंगसाठी तुम्हाला Authority कडून खालील कागदपत्रे घ्यावी लागतील:',
    villageDocsNote: 'बुकिंग कन्फर्म झाल्यानंतर, तुम्हाला ही कागदपत्रे अपलोड करावी लागतील. Admin/Operator पडताळणी करतील, त्यानंतरच पायलट उड्डाण करेल.',
    departureDate: 'प्रस्थान तारीख',
    pickupTime: 'पिकअप वेळ',
    additionalOptions: 'अतिरिक्त पर्याय (ऐच्छिक)',
    waitingTime: 'प्रतीक्षा वेळ (मिनिटे)',
    waitingTimeNote: 'पहिली 30 मिनिटे मोफत, नंतर शुल्क लागू',
    nightHalts: 'रात्री मुक्काम',
    nightHaltsNote: 'क्रू निवास शुल्क समाविष्ट',
    bookingSummary: 'बुकिंग सारांश',
    aircraftTypeLabel: 'विमान प्रकार:',
    totalPassengersLabel: 'एकूण प्रवासी:',
    adults: 'प्रौढ',
    childrenLabel: 'मुले',
    flightTypeLabel: 'उड्डाण प्रकार:',
    pickupLabel: 'पिकअप:',
    dropLabel: 'ड्रॉप:',
    distanceLabel: 'अंतर:',
    dateTimeLabel: 'तारीख आणि वेळ:',
    at: 'रोजी',
    villageApprovalTitle: 'गाव लँडिंग - अ‍ॅडमिन मंजुरी आवश्यक',
    villageApprovalDesc: 'तुमची चौकशी अ‍ॅडमिन मंजुरीसाठी पाठवली जाईल. मंजुरीनंतर पेमेंट सुरू होईल.',
    priceBreakdown: 'किंमत तपशील',
    baseFlightCost: 'उड्डाण खर्च',
    flightCost: 'उड्डाण खर्च',
    positioningCost: 'पोझिशनिंग खर्च (डेड-लेग)',
    roundTripDiscount: 'राउंड ट्रिप सूट',
    operatorGrossCost: 'ऑपरेटर एकूण खर्च',
    additionalCharges: 'अतिरिक्त शुल्क',
    waitingGroundHolding: 'प्रतीक्षा / ग्राउंड होल्डिंग',
    nightHalt: 'रात्री मुक्काम ({{count}} रात्री)',
    crewAccommodation: 'क्रू निवास आणि भोजन',
    fuelSurcharge: 'इंधन अधिभार',
    platformFees: 'प्लॅटफॉर्म शुल्क',
    convenienceFee: 'सुविधा शुल्क',
    insurance: 'विमा',
    peakSurge: 'पीक सीझन सर्ज',
    platformCommission: 'प्लॅटफॉर्म कमिशन',
    included: 'समाविष्ट',
    helipadCharges: 'हेलिपॅड लँडिंग शुल्क',
    totalLandingCharges: 'एकूण लँडिंग शुल्क',
    taxableAmount: 'करपात्र रक्कम',
    totalGst: 'एकूण GST',
    grandTotal: 'एकूण रक्कम',
    inclusiveTaxes: 'सर्व करांसह',
    operatorReceives: 'ऑपरेटरला मिळेल',
    specialRequirements: 'विशेष आवश्यकता (ऐच्छिक)',
    specialRequirementsPlaceholder: 'कोणतीही विशेष विनंती किंवा आवश्यकता...',
    submitting: 'पाठवत आहे...',
    submitApproval: 'मंजुरीसाठी पाठवा',
    generateInquiry: 'चौकशी पाठवा',
    approvalNote: 'गाव लँडिंगसाठी अ‍ॅडमिन मंजुरी आवश्यक आहे.',
    inquiryNote: 'चौकशीनंतर, ऑपरेटर तुम्हाला कोट पाठवतील.',
    formRestored: 'फॉर्म डेटा पुनर्संचयित!',
    selectAircraftError: 'कृपया विमान प्रकार निवडा',
    minAdultError: 'किमान 1 प्रौढ प्रवासी आवश्यक',
    maxChildrenError: 'जास्तीत जास्त 2 मुले',
    selectFlightTypeError: 'कृपया उड्डाण प्रकार निवडा',
    selectBookingForError: 'कृपया बुकिंग कोणासाठी ते निवडा',
    selectPurposeError: 'कृपया बुकिंग उद्देश निवडा',
    selectPickupError: 'कृपया पिकअप ठिकाण निवडा',
    selectDropError: 'कृपया ड्रॉप ठिकाण निवडा',
    selectDateError: 'कृपया प्रस्थान तारीख निवडा',
    selectTimeError: 'कृपया पिकअप वेळ निवडा',
    priceWaitError: 'किंमत मोजली गेली नाही! कृपया प्रतीक्षा करा',
    inquirySubmitted: 'चौकशी सबमिट झाली! ऑपरेटर लवकरच उत्तर देतील',
    noteVillageApproval: 'गाव लँडिंगसाठी अ‍ॅडमिन मंजुरी आवश्यक',
    notePriceEngine: 'एव्हिएशन-ग्रेड प्राइसिंग इंजिनद्वारे गणना',
    noteFinalPrice: 'अंतिम किंमत ऑपरेटरद्वारे निश्चित होईल',
    docCollectorNoc: 'कलेक्टर NOC',
    docFireDept: 'अग्निशमन विभागाची पोचपावती',
    docPoliceStation: 'स्थानिक पोलीस स्टेशनची पोचपावती',
    docSpDcp: 'SP/DCP पोचपावती',
  },
  options: {
    helicopter: 'हेलिकॉप्टर',
    chartered_plane: 'चार्टर्ड विमान',
    one_hour: '1 तासाचे उड्डाण',
    two_hour: '2 तासांचे उड्डाण',
    half_day: 'अर्धा दिवस',
    full_day: 'पूर्ण दिवस',
    multi_city: 'बहु-शहर',
    point_to_point: 'पॉइंट-टू-पॉइंट',
    self: 'स्वतःसाठी',
    friend_family: 'मित्र आणि कुटुंब',
    company: 'कंपनी / कॉर्पोरेट',
    political: 'राजकीय / VIP',
    other: 'इतर',
    wedding: 'लग्न',
    temple_yatra: 'मंदिर यात्रा',
    company_tour: 'कॉर्पोरेट टूर',
    election_tour: 'निवडणूक प्रचार',
    medical_emergency: 'वैद्यकीय आणीबाणी',
    film_shooting: 'चित्रपट शूटिंग',
    general_tour: 'सामान्य सहल',
    pilgrimage: 'तीर्थयात्रा',
    business: 'व्यवसाय बैठक',
  },
};

export default mr;
